export default {
  menu: 'Sales',
  title: 'Sales',

  general: {
    labels: {
      id: 'Invoice ID',
      user: 'Customer',
      fullName: 'Full Name',
      address: 'Address',
      email: 'Email',
      registryDate: 'Registration Date',
      orderDate: 'Order Date',
      phoneNumber: 'Phone number',
      pre: 'pre',
      status: 'Status',
      channel: 'Channel',
      gift: 'Gift',
      giftAccount: 'Gift account',
      store: 'Store',
      note: 'Note',
      cooperation: 'Cooperation',
      availableProduct: 'Available Products',
      allProduct: 'Products',

      productPrice: 'Products price',
      servicePrice: 'Services price',
      tax: 'Vat amount',
      totalDiscount: 'Discount',
      totalVatExc: 'Total (vat EXC)',
      totalPrice: 'Total price',
      totalVatInc: 'Total',
      grandTotal: 'Grand total',
      shipping: 'Shipping',
      required: '(required)',
      totalCount: 'Qty',
      totalVat: 'Total vat',
      total: 'Amount',
      totalGrand: 'Grand total',
      TRN: 'TRN: ',
      vatExc: 'vat Exc',
      vatInc: 'vat Inc',
      vatContainTextBefore: 'includes ',
      vatContainTextAfter: 'VAT amount',
      attachmentLabel: 'Attachment {key}',
      services: {
        name: 'Service name',
        quantity: 'Quantity',
        price: 'Price'
      }
    },

    placeholders: {
      id: 'Automatic'
    },

    prompts: {
      receive: {
        title: 'Receive money from the customer',
        dynamicTitle: 'Receive funds from {name}',

        subject: 'Sales invoice number {id}',

        actions: {
          payment: 'Pay',
          cancel: 'Cancel',
          draft: 'Draft'
        }
      },

      confirm: {
        title: 'Create sale invoice confirmation',

        actions: {
          payment: 'Confirm',
          cancel: 'Cancel'
        }
      },

      sendMail: {
        title: 'Send sale invoice to email'
      },

      address: {
        insert: {
          title: 'Add new address',
          dynamicTitle: 'Add new address for {name}'
        },

        list: {
          title: 'Address List',
          dynamicTitle: 'Address List {name}'
        }
      },

      users: {
        list: {
          title: 'User List'
        },
        insert: {
          title: 'Add new user'
        }
      },

      noteDialog: {
        title: 'Customer Invoice Note'
      },

      activeInvoiceExist: {
        actions: {
          confirm: 'Invoice status changed, Save'
        }
      }
    },

    actionTypes: {
      present: 'Retail',
      tel: 'Telephone',
      internet: 'Internet'
    },

    categoryTypes: {
      domestic: 'Domestic',
      export: 'Export',
      gift: 'Gift'
    },

    processTypes: {
      proformaInvoices: 'Draft',
      invoices: 'Invoice',
      storeExit: 'Pull out',
      incomplete: 'Incomplete',
      deleted: 'Deleted',
      voided: 'Voided',
      failed: 'Failed'
    },

    notifications: {
      isExists: {
        message: 'This value is in the list',
        dynamicMessage: 'There are {name} in the list'
      },

      increaseCount: {
        message: 'Number of items added',
        dynamicMessage: 'Number of { names } added'
      },

      productNotFount: 'No product found with this barcode',
      quantity: 'Inventory is not enough!',
      dynamicQuantity: 'There is not enough stock of {name}!',
      activeRefundInvoiceExists: 'For this invoice, return invoice {invoices} are created. First, change the status of these invoices to draft | For this invoice, return invoices {invoices} are created. First, change the status of these invoices to draft',
      lowBalance: 'Draft was registered, but due to lack of customer credit, it is necessary to receive money to complete the invoice!',
      discountIsBigger: 'The discount of {name} is more than the total price of the product!',
      taxNumberExist: 'Invoice has tax number!',
      priceChange: 'Invoice price updated',
      cantUpdate: 'Invoice cant update because status is not draft',

      insert: {
        success: 'Invoice registered successfully',
        error: 'Invoice registration was incorrect!'
      },

      edit: {
        success: 'Invoice edited successfully',
        error: 'Invoice editing encountered an error!'
      },

      delete: {
        success: 'Invoice successfully deleted',
        error: 'Deleting the sales invoice was accompanied by an error'
      },

      restore: {
        success: 'Invoice successfully restored',
        error: 'Restore sales invoice was accompanied by an error'
      },

      refreshStatus: {
        success: 'Invoice Status Returned Successfully',
        error: 'Return invoice status has error'
      },

      parseError: {
        user: 'Customer not selected!',
        accountSide: 'Account side not selected!',
        lines: 'No items selected!',
        address: 'The address was not entered correctly!',
        storeroom: 'Warehouse not selected!',
        invoiceNumber: 'This invoice number is already selected!',
        quantity: 'The number of selected products is not valid!',
        discount: 'The entered discount is not valid!',
        taxRate: 'The entered vat is not valid!',
        dynamicDiscount: 'The entered discount in row {index} is not valid!',
        dynamicUnitPrice: 'The unit price in row {index} is not valid, it cant be less than sale price!',
        noProductEnter: 'No Product Selected!',
        cooperationId: 'No user selected for cooperation',
        cooperationPrice: 'Cooperation price is not valid',
        receiveType: 'Receive type is not valid',
        actionType: 'Channel is not valid'
      }
    },

    confirmations: {
      delete: {
        title: 'Confirmation of deletion of sales invoice',
        body: 'If the sales invoice is deleted, all the documents and delivery note of the warehouse related to the invoice will be deleted. Are you sure? '
      },
      forceDelete: {
        title: 'Confirmation of deletion of sales invoice',
        body: 'If the sales invoice is deleted, the information of invoice deleted and cant restore it. Are you sure? '
      },
      preInvoiceWithoutQuantity: {
        title: 'Pre-sale invoice confirmation',
        body: 'Some of the selected products are out of stock. Are you sure of confirming the invoice as a draft?'
      },
      freeInvoice: {
        title: 'Free sale invoice confirmation',
        body: 'Sale invoice is free. Are you sure of confirming the invoice?'
      },
      changeUnitPrice: {
        title: 'Change unit price confirmation',
        body: 'Sale invoice unit price changed. Are you sure of confirming the invoice?'
      },
      forceUpdate: {
        title: 'Sale invoice edit confirmation',
        body: 'By edit sale invoice, All documents related to this invoice change. Are you sure of confirming edit sale invoice?',
        taxNumberBody: 'By edit sale invoice, All documents related to this invoice change. {danger} Are you sure of confirming edit sale invoice? ',
        taxNumberBodyDanger: 'This invoice has tax number!'
      }
    }
  },

  list: {
    title: 'Sales',

    table: {
      header: {
        id: 'Number',
        receivedId: 'Reference',
        creator: 'Creator',
        user: 'Customer',
        province: 'Province',
        country: 'Country',
        date: 'Date',
        totalDiscount: 'Discount',
        totalVat: 'Vat',
        shipping: 'Shipping',
        finalPrice: 'Grand Amt',
        type: 'Type',
        channel: 'Channel',
        category: 'Category',
        status: 'Status',
        score: 'Point',
        lastModifiedDate: 'Update',
        restore: 'Restore',
        delete: 'Delete'
      },

      filters: {
        type: {
          all: 'All',
          present: 'Retail',
          tel: 'Telephone',
          internet: 'Internet'
        },
        status: {
          all: 'All',
          proformaInvoices: 'Draft',
          invoices: 'Invoice',
          storeExit: 'Pull out',
          incomplete: 'Incomplete'
        }
      }
    },

    actionTypes: {
      present: 'Retail',
      tel: 'Telephone',
      internet: 'Internet'
    }
  },

  insert: {
    title: 'Add sales invoice',
    dynamicTitle: 'Add {name} Invoice',

    telTypeTitle: 'Add Telephone Invoice',
    presentTypeTitle: 'Add Retail Sales Invoice',

    table: {
      header: {
        rowNumber: 'Row',
        barcode: 'Barcode',
        name: 'Product / Service',
        variant: 'Variable',
        storeroom: 'Store',
        count: 'Qty',
        tax: 'Vat',
        unitTax: 'Unit vat',
        unitPrice: 'Unit',
        totalPrice: 'Total',
        discount: 'Discount',
        unitDiscount: 'Unit Disc.',
        netUnit: 'Net unit',
        subTotal: 'Sub total',
        finalPrice: 'Total',
        delete: 'Delete'
      }
    }
  },

  invoice: {
    title: 'Sale Invoice',
    dynamicTitle: '{type} Sale {pre} Invoice No. {id}',
    dynamicTitleWithoutId: '{type} Sale Invoice',

    general: {
      labels: {
        payment: 'payment',
        cancel: 'Cancel'
      },

      table: {
        header: {
          rowNumber: 'Row',
          barcode: 'Barcode',
          name: 'Product / Service',
          description: 'Description',
          variant: 'Variable',
          storeroom: 'Store',
          count: 'Qty',
          tax: 'Vat Amount',
          taxRate: 'Vat',
          unitTax: 'Unit vat',
          unitPrice: 'Unit price',
          totalPrice: 'Total',
          discount: 'Discount',
          gift: 'Gift',
          unitDiscount: 'Unit Disc.',
          netUnit: 'Net unit',
          netUnitTaxable: 'Net taxable',
          subTotal: 'Amount',
          finalPrice: 'Total',
          totals: 'Totals',
          delete: 'Delete'
        }
      },

      validators: {
        user: 'Supplier not selected!',
        products: 'No product selected!',
        store: 'Warehouse not selected!',
        unitPrice: 'The amount of the goods has not been entered!',
        invoiceNumber: 'This invoice number is already selected!',
        quantity: 'Inventory is not enough!',
        lowPrice: 'Draft was registered, but due to lack of customer credit, you need to receive money to complete the invoice!'
      },

      notifications: {
        complete: {
          success: 'Invoice registered successfully',
          error: 'Invoice registration was incorrect!'
        },

        sendMail: {
          success: 'Invoice send to email successfully',
          error: 'Send invoice to email has error!'
        },

        storeExit: {
          error: 'Sale invoice not exit from warehouse'
        }
      },

      actionTypes: {
        present: 'Retail',
        tel: 'Telephone',
        internet: 'Internet'
      },

      actions: {
        print: 'Print',
        back: 'Back'
      }
    },

    logs: {
      title: 'Sale invoice Logs'
    },

    print: {
      title: 'Sale invoice',
      preInvoice: 'Draft ',
      taxInvoice: 'Tax invoice ',

      labels: {
        date: 'Date',
        documentNumber: 'No',
        note: 'Note',
        TRN: 'TRN',
        printNumber: 'No',
        shipTo: 'To',
        shipFrom: 'From',
        phone: 'Phone',
        address: 'Address',
        total: 'Total',
        beforeTax: 'Before vat',
        tax: 'Vat',
        totalTax: 'Total vat',
        afterTax: 'After vat',
        totalDiscount: 'Total discount',
        totalPrice: 'Subtotal',
        finalPrice: 'Grand total',
        shipping: 'Shipping',
        bankInfo: 'Bank Info',
        accountName: 'Account Name',
        bankName: 'Bank Name',
        iban: 'IBAN',
        cardNumber: 'Card number',
        swiftCode: 'Swift code',
        vatExc: 'vat Exc',
        vatInc: 'vat Inc'
      },

      table: {
        header: {
          row: 'No',
          barcode: 'Barcode',
          description: 'Item Description',
          count: 'Qty',
          tax: 'Vat',
          unitPrice: 'Unit',
          unitPriceVatExc: 'Unit (vat Exc)',
          netPrice: 'Net unit',
          totalPrice: 'Total price',
          discount: 'Disc.',
          unitDiscount: 'Unit Disc.',
          finalPrice: 'Net Amt',
          subTotal: 'Sub total'
        }
      }
    }
  },

  edit: {
    title: 'Edit Sale Invoice',
    dynamicTitle: 'Edit {type} Sale Invoice',

    labels: {
      first: 'first',
      second: 'second'
    },

    table: {
      header: {
        rowNumber: 'Row',
        barcode: 'Barcode',
        name: 'Product',
        variant: 'Variable',
        store: 'Store',
        count: 'Qty',
        unitPrice: 'Price (vat Exc)',
        totalPrice: 'Amount',
        discount: 'Discount',
        finalPrice: 'Total (vat Inc)',
        delete: 'Delete'
      }
    },

    actionTypes: {
      present: 'Retail',
      tel: 'Telephone',
      internet: 'Internet'
    }
  },

  trash: {
    title: 'Sale invoice trash list'
  },

  refreshStatus: {
    title: 'Return the sales invoice status',

    description: 'Keep in mind that if the invoice status is returned, all documents and delivery note related to each status will be deleted',

    confirm: 'Confirm',
    cancel: 'Cancel'
  },

  activeInvoiceExist: {
    title: 'In order to apply the changes, the status of the following invoices must first be changed to draft',

    table: {
      header: {
        id: 'Invoice number',
        type: 'Type',
        user: 'Customer',
        date: 'Date',
        status: 'Status'
      }
    },

    invoiceTypes: {
      1: 'Sale',
      2: 'Purchase',
      3: 'Sale Refund',
      4: 'Purchase Refund'
    }
  }
}
